import React from "react";
import GameTemplate from "../molecules/GameTemplate/GameTemplate";
import { connect } from "react-redux";
import { updateStateGame } from "../../state/actions/AccountActions";

class Game extends React.Component {
    
    componentWillUnmount(){
        const { handleCloseGame }: any = this.props;
        handleCloseGame(false);
    }
    render(){
        return (
            <article>
                <GameTemplate />
            </article>
        )
    }
    
}
const mapStateToProps = ({ Account }: any) => ({ Account });
const mapDispatchToProps = (dispatch: any) => ({
    handleCloseGame(payload: any) {
        dispatch(updateStateGame(payload));

    }
})
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Game);